module.exports = __webpack_public_path__ + "img/193.57eceaaa.jpg";